export default __webpack_public_path__ + "static/media/DSC_0547.d2e235aa.webp";